import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'iv-checkbox-option',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
})
export class CheckboxComponent implements OnInit {

  @Input() model;
  @Input() label;
  @Input() subLabel;
  @Input() key;
  @Input() disabled = false;
  @Input() customStyles = null;
  @Input() subcontentCustomStyles = null;
  @Input() labelCustomStyles = null;

  @Output() checkboxChanged = new EventEmitter();
  @Input() controlid = '';
  @Input() isRequired: boolean = false;
  constructor() { }

  ngOnInit() { }

  save(value) {
    let changes = {};
    changes[this.key] = value;
    // Check for Money In Trust updates, on unchecked, we need to set up the fields related to null
    if (this.key === 'money_in_trust') {
      const money_in_trust_fields = {
        trust_code: null,
        trust_receipt_date: null,
        receipt_number: null,
        receipt_amount: null
      };
      changes = {...changes, ...money_in_trust_fields};
    }
    // Consolidate Disbursements
    if (this.key === 'consolidated_expense') {
      const consolidated_expense_fields = {
        'invoice_header': ''
      };
      changes = {...changes, ...consolidated_expense_fields};
    }
    if (this.key === 'counter_party_rep_check') {
      const counter_party_rep_fields = {
        'counter_party_rep1': '',
        'counter_party_rep2': '',
        'counter_party_rep3': ''
      };
      changes = {...changes, ...counter_party_rep_fields};
    }
    this.checkboxChanged.emit(changes);
  }
}
